const apiGatewayUrl = process.env.VUE_APP_API_GATEWAY_URL;

const constants = {
  Cookies: {
    LanguagePreference: 'lang_pref',
  },
  UrlParameters: {
    LanguagePreference: 'lang',
  },
  UrlEndings: {
    NrsHome: '/nrs/home/',
    DataProcessingAddendum: 'dpa.pdf',
  },
  Languages: {
    English: 'en-us',
    Chinese: 'zh-cn',
    Japanese: 'ja',
  },
  Api: {
    Unsubscribe: `${apiGatewayUrl}/v1/nrsservice/user/umpUnsubscribeFromPage`,
    GetUmpUser: `${apiGatewayUrl}/v1/nrsservice/user/UmpUser/{userGuid}`,
    OmUnsubscribe: `${apiGatewayUrl}/om/OM.Services/api/emailsubscription/unsubscribefromemails`,
    GetOmUser:`${apiGatewayUrl}/om/OM.Services/api/emailsubscription/getUnSusbcribeEmail`
  },
};

export default constants;
